export const getLimitActions = (limitActions) => limitActions
    .split(',')
    .map(action => action.trim())
    .filter(Boolean);

export const getUserLimitAction = (actualLimits) => Object.values(actualLimits).find(limit => limit.action)?.action;

export const prepareLimitsForSave = (prev, next, availablePeriods) => ({
    limits: availablePeriods
        .filter(period => next[period] !== prev[period])
        .map((timePeriod) => ({
            amount: next[timePeriod] || '0',
            timePeriod
        })),
    action: next.action
});

export const getLeftPosition = (el, width) => {
    const period = el?.timePeriod;

    if (!period) {
        return;
    }

    const elem = document.querySelector(`[data-time=${period}]`);
    const child = elem?.querySelector('figcaption');

    if (elem && child) {
        const parent = elem.parentElement;

        if (elem.offsetWidth < child.offsetWidth / 2) {
            child.dataset.position = '';
            return '0px';
        } else if (elem.offsetWidth + child.offsetWidth / 2 > parent.offsetWidth) {
            child.dataset.position = '';
            return `calc(${parent.offsetWidth - width}px - 0.25em)`;
        }

        child.dataset.position = 'middle';
        return `calc(100% - ${child.offsetWidth / 2}px)`;
    }
};

export const togglePendingSection = (e) => {
    const periodInDom = e.target.closest('[data-period]');

    if (periodInDom && periodInDom.querySelector('[data-pending]')) {
        const data = periodInDom.querySelector('[data-pending]').dataset;

        data.pending === 'true' ?
            data.pending = false :
            data.pending = true;
    }
};
